import React from 'react';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { GraySmall } from 'src/theme/colors';

/**
 * This component is responsible of rendering the clone workspace onboarding
 * step subtitle.
 * @param templateName
 */
export const CloneWorkspaceSubTitle: React.FC<{
  templateName?: string;
}> = ({ templateName }) => {
  if (templateName) {
    return (
      <BaseTypography
        style={{
          color: GraySmall,
        }}
      >
        You're cloning the {templateName} workspace
      </BaseTypography>
    );
  }

  return (
    <BaseTypography
      style={{
        color: GraySmall,
      }}
    >
      You're cloning a workspace
    </BaseTypography>
  );
};
